export default __webpack_public_path__ + "static/media/twoPartyLedger_sample.e16d00b2.jpg";